var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6675 26.6675C47.7249 26.6675 45.3325 29.0575 45.3325 32C45.3325 34.9425 47.725 37.3325 50.6675 37.3325C53.6075 37.3325 55.9999 34.9425 55.9999 32C55.9999 29.0575 53.6074 26.6675 50.6675 26.6675ZM31.9999 24C27.59 24 23.9999 27.59 23.9999 32C23.9999 36.41 27.59 40 31.9999 40C36.4099 40 39.9999 36.41 39.9999 32C39.9999 27.59 36.4099 24 31.9999 24ZM18.6675 32C18.6675 34.9425 16.2749 37.3325 13.3325 37.3325C10.3924 37.3325 8 34.9425 8 32C8 29.0575 10.3925 26.6675 13.3325 26.6675C16.275 26.6675 18.6675 29.0575 18.6675 32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.d09be516.svg";
export { ForwardRef as ReactComponent };